import classNames from 'classnames';
import Div100vh from 'react-div-100vh';

import {LanguageSwitcher, Copyright, ClientLogo, IconName, Icon} from 'components';
import {imageUtils} from 'utils';

type Props = {
    icon?: IconName;
    image?: string;
    hasLogo?: boolean;
    hasTranslate?: boolean;
    children: React.ReactNode;
};

export const UnauthorizedLayout: React.FC<Props> = (({icon, image, children, hasLogo = true, hasTranslate = true}) => (
    <Div100vh style={{width: '100vw'}}>
        <div className='tw-bg-layout tw-flex tw-flex-col tw-h-full tw-overflow-auto tw-p-4 sm:tw-p-12'>
            <div className='tw-flex tw-flex-wrap tw-justify-between tw-items-end sm:tw-items-start'>
                {hasLogo &&
                    <ClientLogo image={image || imageUtils.getLogo()} className='tw-h-8 tw-order-1' />}
                {icon &&
                    <div className='sm:tw-w-auto tw-flex-center tw-mt-6 sm:mt-4 tw-order-3 sm:tw-order-2 tw-m-auto tw-w-full'>
                        <Icon
                            name={icon}
                            size='initial'
                            color='primary-light'
                            className='tw-w-28 sm:tw-w-32 tw-mb-0 sm:tw-mb-8 tw-opacity-25'
                        />
                    </div>}
                {hasTranslate && <LanguageSwitcher className='tw-w-40 tw-order-2 sm:tw-order-3' />}
            </div>
            <div className={classNames('tw-flex tw-self-center tw-flex-1 tw-my-8')}>
                {children}
            </div>
            <div className='tw-self-center sm:tw-self-start tw-text-default-dimmed'>
                <Copyright />
            </div>
        </div>
    </Div100vh>
));
